import { defineMessages } from 'react-intl';

/**
 * Messages for the Unit Compliance component
 */
const messages = defineMessages({
  title: {
    id: 'App.UnitCompliance.Title',
    defaultMessage: 'Unit Compliance',
  },
  subtitle: {
    id: 'App.UnitCompliance.Subtitle',
    defaultMessage: 'Next Available Unit Rule (NAUR)',
  },
  naurTableTitle: {
    id: 'App.UnitCompliance.NAURTableTitle',
    defaultMessage: 'NAUR Triggering Unit(s)',
  },
  naurBannerMessage: {
    id: 'App.UnitCompliance.NAURBannerMessage',
    defaultMessage: 'These units are no longer in compliance.',
  },
  naurBannerLink: {
    id: 'App.UnitCompliance.NAURBannerLink',
    defaultMessage:
      'Click Here to change the next available unit for Affordable Housing',
  },
  buildingNumber: {
    id: 'App.UnitCompliance.BuildingNumber',
    defaultMessage: 'Building Number',
  },
  programName: {
    id: 'App.UnitCompliance.ProgramName',
    defaultMessage: 'Program Name',
  },
  floorplan: {
    id: 'App.UnitCompliance.Floorplan',
    defaultMessage: 'Floorplan',
  },
  setAside: {
    id: 'App.UnitCompliance.SetAside',
    defaultMessage: 'Set-Aside',
  },
  unitNumber: {
    id: 'App.UnitCompliance.UnitNumber',
    defaultMessage: 'Unit Number',
  },
  bedBathCount: {
    id: 'App.UnitCompliance.BedBathCount',
    defaultMessage: 'Bed/Bath Count',
  },
  squareFootage: {
    id: 'App.UnitCompliance.SquareFootage',
    defaultMessage: 'Square Footage',
  },
  headOfHousehold: {
    id: 'App.UnitCompliance.HeadOfHousehold',
    defaultMessage: 'Head of Household',
  },
  naurStatus: {
    id: 'App.UnitCompliance.NaurStatus',
    defaultMessage: 'NAUR Status',
  },
  buildingBIN: {
    id: 'App.UnitCompliance.BuildingBIN',
    defaultMessage: 'Building BIN',
  },
  lastCertified: {
    id: 'App.UnitCompliance.LastCertified',
    defaultMessage: 'Last Certified',
  },
  oiPercent: {
    id: 'App.UnitCompliance.OIPercent',
    defaultMessage: 'OI %',
  },
  lastCertIncome: {
    id: 'App.UnitCompliance.LastCertIncome',
    defaultMessage: 'Last Cert Income',
  },
  incomeLimit: {
    id: 'App.UnitCompliance.IncomeLimit',
    defaultMessage: 'Income Limit',
  },
  satisfyingUnit: {
    id: 'App.UnitCompliance.SatisfyingUnit',
    defaultMessage: 'Satisfying Unit #',
  },
  scheduledFloorplanConversion: {
    id: 'App.UnitCompliance.ScheduledFloorplanConversion',
    defaultMessage: 'Scheduled Floorplan Conversion',
  },
  satisfyingUnitFloorplan: {
    id: 'App.UnitCompliance.SatisfyingUnitFloorplan',
    defaultMessage: 'Satisfying Unit Floorplan',
  },
  satisfyingUnitBedBath: {
    id: 'App.UnitCompliance.SatisfyingUnitBedBath',
    defaultMessage: 'Satisfying Unit Bed/Bath Count',
  },
  satisfyingUnitStatus: {
    id: 'App.UnitCompliance.SatisfyingUnitStatus',
    defaultMessage: 'Satisfying Unit Status',
  },
  moveOutDate: {
    id: 'App.UnitCompliance.MoveOutDate',
    defaultMessage: 'Move-out Date',
  },
  applicantName: {
    id: 'App.UnitCompliance.ApplicantName',
    defaultMessage: 'Applicant Name',
  },
  incomeAtMoveIn: {
    id: 'App.UnitCompliance.IncomeAtMoveIn',
    defaultMessage: 'Income at Move-in',
  },
  oiCert: {
    id: 'App.UnitCompliance.OICert',
    defaultMessage: 'OI Cert',
  },
  naurCert: {
    id: 'App.UnitCompliance.NaurCert',
    defaultMessage: 'NAUR Cert',
  },
  actions: {
    id: 'App.UnitCompliance.Actions',
    defaultMessage: 'Actions',
  },
  selectBuildingPrompt: {
    id: 'App.UnitCompliance.SelectBuildingPrompt',
    defaultMessage: 'Select non-compliant building(s) above to view details.',
  },
  noNaurEventsMessage: {
    id: 'App.UnitCompliance.NoNaurEventsMessage',
    defaultMessage: 'No NAUR events found for the selected building(s).',
  },
});

export default messages;
